import { Component } from 'react';

export default class ScrollComponent extends Component {
  constructor() {
    super();
    this.scrollHandler = this._handleScroll.bind(this);
  }

  _handleScroll(event) {
    const doc = document.documentElement;
    const top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    this.onScroll(event, top);
  };

  componentDidMount() {
    window.addEventListener('scroll', this.scrollHandler);
  };

  componentWillUnmount() {
    window.removeEventListener('scroll', this.scrollHandler);
  };

  onScroll() {
    // Override here.
  }
}



// WEBPACK FOOTER //
// ./src/components/ScrollComponent.js